var Model = require("./types/Model.js");
var global = require("global");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");

module.exports = Model({
	name: "backbutton",
	init: init,
	uninit: uninit,

	_handleBack: null,
});

function init() {
	this._handleBack = handle_back.bind(this);

	if(global.BackAndroid){
		global.BackAndroid.addEventListener("hardwareBackPress", this._handleBack);
	} else if (global.document) {
		global.document.addEventListener("backbutton", this._handleBack);
	} else if (ReactNative.BackHandler){
		ReactNative.BackHandler.addEventListener("hadwareBackPress", this._handleBack);
	}
}

function uninit() {
	if(global.BackAndroid){
		global.BackAndroid.removeEventListener("hardwareBackPress", this._handleBack);
	} else if (global.document) {
		global.document.removeEventListener("backbutton", this._handleBack);
	} else if (ReactNative.BackHandler){
		ReactNative.BackHandler.removeEventListener("hardwareBackPress", this._handleBack);
	}
}

function handle_back(e) {
	this.emit("app:button:back");

	if (e && e.preventDefault)
		e.preventDefault();

	return true;
}
